import { observer } from 'mobx-react';
import { SingleValue } from 'react-select';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Note } from '../../../../../../../../components/note/note';
import ListLayout from '../../../../../../../../components/layouts/list-layout/list-layout';
import { IOption, SelectDropdown } from '../../../../../../../../components/inputs/select-dropdown/select-dropdown';
import { FedexV2PinDeliveryOption, IFedexV2MfaOptions } from '../../../../../../../../models/IntegrationsTypes';
import FedexV2MfaStore from '../../../../../stores/credentials/shipping/fedex-v2/fedex-v2-mfa-store';

interface IProps {
    mfa: FedexV2MfaStore;
    mfaOptions: IFedexV2MfaOptions;
}

const FedexV2RegistrationMfaSelectStep: React.FC<IProps> = observer(({ mfa, mfaOptions }) => {
    const secureCodeOptions = mfaOptions.options.secureCode || [];
    const pinDeliveryOptions: IOption[] = secureCodeOptions.map((option) => ({
        label: option,
        value: option,
    }));

    const handlePinDeliveryChange = (option: SingleValue<IOption>) => {
        if (option) {
            mfa.setPinDeliveryOption(option.value as FedexV2PinDeliveryOption);
        }
    };

    return (
        <ListLayout>
            <Note body="Verify ownership of your FedEx account using a secure code PIN." />
            {mfaOptions.email && <Note body={`Email on file: ${mfaOptions.email}`} />}
            {mfaOptions.phoneNumber && <Note body={`Phone on file: ${mfaOptions.phoneNumber}`} />}
            {secureCodeOptions.length > 0 && (
                <FormFieldLine label="PIN delivery method" key="pinOption">
                    <SelectDropdown
                        isSearchable={false}
                        value={pinDeliveryOptions.find((o) => o.value === mfa.pinDeliveryOption) ?? null}
                        options={pinDeliveryOptions}
                        onChange={handlePinDeliveryChange}
                    />
                </FormFieldLine>
            )}
        </ListLayout>
    );
});

export default FedexV2RegistrationMfaSelectStep;
